import { endOfWeek } from 'date-fns';

/**
 * Group the data by week and count the number of applications
 * @param data - The data to group
 * @returns The grouped data
 */
export function groupWeekly({ data }: { data: { dateCreated: string }[] }) {
    // From the data, group by week and count the number of applications, keep the end of week as timestamp
    const groupedData = data.reduce(
        (acc: Record<string, number>, item: { dateCreated: string }) => {
            const weekEndTimestamp = endOfWeek(
                new Date(item.dateCreated)
            ).getTime();
            acc[weekEndTimestamp] = (acc[weekEndTimestamp] || 0) + 1;
            return acc;
        },
        {}
    );

    return {
        series: Object.entries(groupedData)
            .map(([timestamp, value]) => ({
                name: timestamp,
                values: { applicationsCount: value }
            }))
            .sort((a, b) => a.name.localeCompare(b.name))
    };
}
